/** @flow */
import tooltipsTranslations from "@modules/client/tooltips-translations";

export const clientMessages = {
  en: {
    CLIENT_CREATED: "Client was successfully created",
    CLIENT_UPDATED: "Client was successfully updated",
    SERVICE_UPDATED: "Service was successfully updated",
    EMPLOYEE_ASSIGNED: "The Employee was assigned to admin",
    ACCOUNT_CREATED: "The Account was successfully created",
    SLA_MEASURES_UPDATED: "SLA Measures Updated",
    SERVICE_SCOPE_WAS_SUCCESSFULLY_UPDATED: "Service Scope was successfully updated",
    AI_TEAM_SETTINGS_WERE_SUCCESSFULLY_UPDATED: "AI Team settings were successfully updated",
    TICKET_CREATED: "Ticket Created",
    SETTINGS_UPDAtED: "Settings Updated",
  },
};

export default {
  en: {
    ...tooltipsTranslations.en,
    CLIENT_ADMIN: "Client Admin",
    LINE_MANAGER: "Line Manager",
    FULL_ACCESS: "Full Access",
    FULL_HR_ACCESS: "Full Access",
    ADMIN_TITLE: "Admin",
    CLIENT_DATA_TRANSFER: "Data Transfer",
    CLIENT_TREND_VIEWER: "Trend Viewer",
    // SLA
    SERVICE_LEVEL_AGREEMENTS: "Service Level Agreements",
    ADJUST_SLA_MEASURES: "Adjust SLA Measures",
    TARGET: "Target",
    TARGET_PERCENT: "Target %",
    CURRENT_PERCENT: "Current %",
    STATUS: "Status",
    MEASURE: "Measure",
    PERIOD: "Period",
    ENABLED: "Enabled",
    DISABLED: "Disabled",
    QUARTERLY: "Quarterly",
    MONTHLY: "Monthly",
    // Side Nav
    CLIENT_DETAILS: "Client Details",
    EDIT_CLIENT: "Edit Client",
    SLA_MEASURES: "SLA Measures",
    SLA_PERFORMANCE: "SLA Performance",
    INTERACTIONS_BY_TYPE: "Interactions By Type",
    ASAP_CALLBACKS_SLA_PERCENTAGE: "Asap Callbacks SLA Percentage",
    SCHEDULED_CALLBACKS_SLA_PERCENTAGE: "Scheduled Callbacks SLA Percentage",
    NOTIFICATIONS_SLA_PERCENTAGE: "Notifications SLA Percentage",
    PERIOD_TOTAL: "Period Total",
    NO_DATA_PLEASE_APPLY_FILTERS: "No data, please apply filters.",
    SCOPE_AND_FILTERS: "Scope and Filters",
    REPORT_DETAILS: "Report Details",
    ADMIN_ACCOUNTS: "Admin Accounts",
    SERVICE_REVIEWS: "Service Reviews",
    CHANGE_HISTORY: "Change History",
    // Client List
    CLIENT_LIST: "Client List",
    ACTIVE_CLIENTS: "Active Clients",
    HEADCOUNT_COVERED: "Headcount Covered",
    ADD_NEW_CLIENT: "Add New Client",
    UPDATE_CLIENT: "Update Client",
    CLIENT_ID: "Client ID",
    CLIENT_NAME: "Client Name",
    NAME: "Name",
    CLIENT_ABSENCE_LINE: "Client Absence Line",
    OWNER: "Owner",
    HEAD_COUNT: "Headcount",
    UNIQUE_EMPLOYEES: "Unique Employees",
    OPEN_TASKS: "Open Tasks",
    PERCENT_ABSENCES_OVERDUE: "% Absences Overdue",
    PERCENT_CONSENT_WITHHELD: "% Consent Withheld",
    PERCENT_WORK_RELATED: "% Work Related",
    PERCENT_TASKS_OVERDUE: "% Tasks Overdue",
    PERCENT_APP_ADOPTION: "% App Adoption",
    PERCENT_ABSENT: "% Absent",
    PERFORMANCE: "Performance",
    APP: "App",
    INDUSTRY: "Industry",
    ACCOUNT_MANAGER: "Account Manager",
    REVIEW_CHANGES: "Review Changes",
    OVERDUE_CHANGES: "Overdue Changes",
    ADD_CLIENT: "Add Client",
    PROPOSED_BY: "Proposed By",
    SERVICE_ADMIN_TYPE: "Service Admin Type",
    CHANGE_ID: "Change ID",
    SUBMITTED_BY: "Submitted By",
    DATE_SUBMITTED: "Date Submitted",
    CHANGED_BY: "Changed By",
    DATE_CHANGED: "Date Changed",
    COMPLETED_CHANGES_NOTES: "Notes",
    DECISION_DUE_BY: "Decision Due By",
    DETAILS: "Details",
    // Employee Table
    EMPLOYEE_REF: "Employee Ref",
    EMPLOYEE_INFORMATION: "Employee Information",
    ADDITIONAL_DETAILS: "Additional Details",
    PERIOD_TOTALS: "Period Totals",
    FIRST_NAME: "First Name",
    SURNAME: "Surname",
    EMAIL: "Email",
    SELECT: "Select",
    // Admin Account
    CREATE_EMPLOYEE_HEADER: "Create Admin Account: New Employee",
    CREATE_ADMIN_ACCOUNT_ACTION_TEXT: "Create Admin Account",
    CREATE_ADMIN_ACCOUNT_MODAL_HEADER: "Are you sure?",
    CHANGE_LOG: "Change Log",
    DISABLE_ADMIN: "Disable Admin",
    ENABLE_ADMIN: "Enable Admin",
    EXISTING_ADMIN: "Existing Admin",
    EXISTING_ADMIN_ACCOUNTS: "Existing Admin Accounts",
    CREATE_ADMIN_ACCOUNT_EXISTING_EMPLOYEE: "Create Admin Account: Existing Employee",
    CONFIRMATION_CREATE_ADMIN_ACCOUNT:
      "This will grant {firstName} {lastName} with the ability to administer their organisations data, service configuration and hierarchy.",
    CONFIRMATION_DISABLE_ADMIN_ACCOUNT: "Are you sure you want to disable {firstName} {lastName}?",
    CONFIRMATION_ENABLE_ADMIN_ACCOUNT:
      "This will grant {firstName} {lastName} with the ability to administer their organisations data, service configuration and hierarchy.",
    REFERENCE_NUMBER: "Reference Number",
    CREATE_NEW_ADMIN: "Create New Admin",
    CREATE_ADMIN: "Create Admin",
    EXISTING_EMPLOYEE: "Existing Employee",
    NEW_EMPLOYEE: "New Employee",
    CREATE_USING: "Create Using",
    SEARCH_SURNAME: "Search Employees by Surname",
    // Service Admin
    SERVICE_ADMIN: "Service Admin",
    APPROVAL_OUTCOME: "Approval Outcome",
    FROM: "From",
    TO: "To",
    //Service Scope
    APPLICABLE_SERVICES: "Applicable Services",
    MAIN_OPTIONS: "Main Options",
    PRODUCTS: "Products",
    ABSENCE_MANAGEMENT_DEFAULT_CONFIGURATIONS: "Absence Management Default Configurations",
    SELF_SERVICE_ADMINISTRATION: "Self Service Administration",
    ADD_NEW_SERIVCE: "Add New Service",
    ADD_SERVICE: "Add Service",
    SELECT_SERVICE: "Select Service",
    CANT_ENABLE_IF_IN_PAST: "You can't enable a service with start date in the past",
    SERVICE: "Service",
    SERVICE_TYPE: "Service Type",
    CONTRACT_TYPE: "Contract Type",
    START_DATE: "Start Date",
    END_DATE: "End Date",
    SERVICE_STATUS: "Service Status",
    PILOT: "Pilot",
    FULL_HEADCOUNT: "Full Headcount",
    DEFAULT_CONFIGURATIONS: "Default Configurations",
    CALL_HANDLING_CONTROLS: "Call Handling Controls",
    ENHANCED_FEATURE_CONTROLS: "Enhanced Feature Controls",
    ABSENCE_LINE: "Absence Line",
    EMAIL_ADDRESS: "Email Address",
    EMAIL_APPEAR: "Email Appear",
    OVERFLOW: "Overflow",
    BENCHMARKING: "Benchmarking",
    MONITORING: "Monitoring",
    MOBILE_APP: "Mobile App",
    HOMEWORKING_BLOCK: "Homeworking Block",
    FCA_BLOCK: "FCA Block",
    CONSENT_BLOCK: "Consent Block",
    OVERFLOW_SUPPORT: "Overflow Support",
    EAP_SIGNPOSTING: "EAP Signposting",
    ABSENCE_MONITORING: "Absence Monitoring",
    REFERRAL_TRACKING: "Referral Tracking",
    ROLLOUT: "Rollout",
    COMPLETE_SUPPORT: "Complete Support",
    ESSENTIALS: "Essentials",
    FOCUSED: "Focused",
    // Self Service Request
    CHANGE_SET_STATE: "Change Set State",
    DISCARDED: "Discarded",
    DRAFT: "Draft",
    COMMITTED: "Committed",
    PENDING_APPROVAL: "Pending Approval",
    DEFERRED: "Deferred",
    EFFECTIVE: "Effective",
    DECLINED: "Decline",
    API: "API",
    DEVELOPER_HUB_API: "API Developer Hub",
    SERVICES_HUB: "Services Hub",

    //Self Service Requests
    SELF_SERVICE_APPROVALS: "Self Service Approvals",
    PENDING_CHANGES: "Pending Changes",
    PENDING: "Pending",
    CHANGE_REQUEST: "Change Request #{id}",
    BLOCK: "Block",
    DEFER: "Defer",
    APPROVE: "Approve",
    BLOCK_CHANGES: "Block Changes",
    REVIEWED_BY: "Reviewed By",
    DATE_REVIEWED: "Date Reviewed",
    DECISION: "Decision",
    VIEW_CHANGES: "View Changes",
    REASON_FOR_DEFER: "Reason For Defer",
    ADDITIONAL_INFO: "Additional Info",
    ADDITIONAL_INFO_WITH_ID: "Additional Info - Absence #{id}",
    ORIGINAL_VALUE: "Original Value",
    PROPOSED_VALUE: "Proposed Value",
    SECTION: "Section",
    DETAILS_CHANGE_SET: "Details for Change #{id}",
    //Change Log
    HISTORIC_CHANGE_REQUEST_LOG: "Historic Change Request Log",

    // Filter
    APPLY_FILTER: "Apply Filters",

    // Client Details
    ADDRESS_LINE: "Address Line",
    ADDRESS: "Address {number}",
    TOWN_CITY: "Town/City",
    POST_CODE: "Post Code",
    COUNTRY: "Country",
    REGION: "Region",
    SECTOR: "Sector",
    CONTRACT: "Contract",
    ORGANISATION: "Organisation",
    DISABLE_CLIENT: "Disable Client",
    DISABLE_CLIENT_CONFIRMATION_MESSAGE: "Are you intending to close this client down permanently?",
    CLIENT_ADDRESS: "Address",
    CONTRACT_OWNER: "Contract Owner",
    SERVICE_DETAILS: "Service Details",
    OVERFLOW_STATUS: "Overflow Status",
    PRODUCTS_AND_FEATURES: "Products & Features",
    BENCHMARKING_CLASSIFICATIONS: "Benchmarking Classifications",
    CLIENT_NAME_DESCRIPTION:
      "The name of the client. It will automatically appear at the top of the hierarchy structure.",
    CLIENT_ADDRESS_DESCRIPTION: "The head office address of the client.",
    CLIENT_POST_CODE_DESCRIPTION: "The post code of the client’s head office.",
    CLIENT_OWNER_DESCRIPTION: "The provider the client has purchased the GoodShape service from.",
    CLIENT_MANAGER_DESCRIPTION:
      "Select the provider your organisation has purchased the service from.",
    CLIENT_STATUS_DESCRIPTION: "Enable the client to use GoodShape.",
    CLIENT_SUPPRESSION_DESCRIPTION:
      "Block the processing of events, such as alerts, notifications, RTW forms etc.",
    CLIENT_START_DATE_DESCRIPTION: "The date the client’s service officially starts.",
    CLIENT_SERVICE_TYPE_DESCRIPTION:
      "Confirm which version of the platform the client has purchased.",
    CLIENT_ABSENCE_LINE_DESCRIPTION:
      "The dedicated phone number the client’s employees can use to report absences.",
    CLIENT_OVERFLOW_DESCRIPTION:
      "Controls whether the client’s calls can be handled by our Overflow provider.",
    CLIENT_CONSENT_BLOCK_DESCRIPTION:
      "Block the consent to share absence reason question from appearing.",
    CLIENT_SERVICE_STATUS_DESCRIPTION:
      "Enable the client to use GoodShape’s absence management services.",
    CLIENT_COUNTRY_DESCRIPTION: "The country that the client is based in.",
    CLIENT_REGION_DESCRIPTION: "The region in which the client is located.",
    CLIENT_SECTOR_DESCRIPTION: "Confirm whether the organisation is Public or Private.",
    CLIENT_INDUSTRY_DESCRIPTION:
      "The industry the client belongs to. Used in the Benchmarking Index.",
    CLIENT_MONITOR_DESCRIPTION: "Enable the client to use the absence monitoring service.",
    CLIENT_NAVIGATOR_DESCRIPTION:
      "Enable the client to use the Wellbeing Referral service to track OH referrals.",
    CLIENT_DEVELOPER_DESCRIPTION:
      "Enable the client to use the Developer hub for API integration with other systems.",
    CLIENT_MOBILE_APP_DESCRIPTION: "Enable the client’s employees to use the GoodShape app.",
    CLIENT_SERVICE_HUB_DESCRIPTION:
      "Enable the client to promote its other health & wellbeing services through GoodShape.",

    // Overflow support types
    OVERFLOW_ONLY: "Overflow only",

    // Client management statuses
    SUPPRESS_EVENTS: "Suppress Events",
    ACTIVE: "Active",
    INACTIVE: "Inactive",
    APP_SETTINGS: "App Settings",
    APP_SETTINGS_INFO:
      "These settings are used to control the appearance of certain features within the GoodShape app. Disabled features will not be shown in the app for your employees. Enabled features will be available for your employees to use.",
    SHOW_NOTIFICATION_CONTACTS: "Show Notification Contacts",
    SHOW_WORK_RELATED_ABSENCE_WARNING: "Show Work Related Absence Warning",
    SHOW_TRIGGERING_ALERTS: "Show Triggered Alerts",
    ALLOW_DOCUMENT_UPLOAD: "Allow Document Upload",
    ENABLE_MANAGER_MODE: "Enable Manager Mode",
    SHOW_NOTIFICATION_CONTACTS_DESCRIPTION:
      "Allow employees to see a list of the Notification Contacts that are informed of their absences.",
    SHOW_WORK_RELATED_ABSENCE_WARNING_DESCRIPTION:
      "Display a warning to employees about the potential consequences of falsely claiming an absence is work related.",
    SHOW_TRIGGERING_ALERTS_DESCRIPTION:
      "Inform employees of any absence policy alerts that their reported absence has triggered.",
    ALLOW_DOCUMENT_UPLOAD_DESCRIPTION:
      "Enable employees to upload documents to their open absences. They will appear for managers & HR to see.",
    ENABLE_MANAGER_MODE_DESCRIPTION: `Enable Managers, Advanced Users, Full Access and Admins to see "My Team" section, showing open absences and outstanding tasks for the employees they are a full contact for.`,

    // AI Settings
    AI_FEATURES: "AI Features",
    AI_TEAM: "AI Team",
    AI_TEAM_DESCRIPTION: "Enable the AI Absence Management Team.",
    AI_AGENTS_ONLY_APPEAR_IF_THEY_ARE_ENABLED_BY_YOUR_ORGANISATION:
      "While GoodShape AI includes a full team of AI Agents, your organisation may have chosen to only enable some of them. If you do not see an AI Agent, it means that either they are not available for your user type, or that your organisation has chosen not to enable the AI agent.",
    BOMAN_DESCRIPTION:
      "Customer Service Advisor that helps managers with queries and trains them on the platform.",
    CLAUDIA_DESCRIPTION:
      "Wellbeing Assistant that supports employees and signposts them to advice, services and tools that may help.",
    MORGAN_DESCRIPTION:
      "Data Scientist that helps HR and Senior Managers to analyse and interpret absence data trends.",
    SHANI_DESCRIPTION:
      "Policy Advisor who can support Admins with service configuration and absence policy management.",

    // AI Team modal - new chat screen
    AI_TEAM_NEW_CHAT_GREETING: "Hello! How can I help?",
    AI_TEAM_NEW_CHAT_BOMAN:
      "As GoodShape's customer support advisor, I'm here to help if you get stuck anywhere in the system. I don't have access to any data, or admin privileges, but I can teach you what things are and how they work and tell you where to go when you're unsure what to do.",
    AI_TEAM_NEW_CHAT_CLAUDIA:
      "As your Wellbeing Assistant, I can help navigate you to all the advice and support that GoodShape make available, including content from our advice library and services hub.",
    AI_TEAM_NEW_CHAT_MORGAN:
      "As your Data Scientist, I can help you analyse absence patterns, investigate concerning trends, examine potential risks, produce league tables and even predict futures absence levels.",
    AI_TEAM_NEW_CHAT_SHANI:
      "As your Admin Assistant I can help you enable or disable settings, configure return to work forms, update alerts, change security controls and much more. I can also let you know about any known service issues.",

    // AI Team modal - landing page
    AI_TEAM_LANDING_INTRODUCTION_TITLE: "Introduction",
    AI_TEAM_LANDING_INTRODUCTION_TEXT:
      "GoodShape AI is a team of AI Agents available to support employees, managers and HR teams to manage and reduce absence. The AI Team is available 24/7 and each team member has a specific role and purpose. To learn more about each team member, click on their icon.",
    AI_TEAM_LANDING_TRAINING_TITLE: "Training",
    AI_TEAM_LANDING_TRAINING_TEXT:
      "None of your organisation's data is used to train the AI Agents. All training is based on GoodShape documentation and data only.",
    AI_TEAM_LANDING_DATA_RETENTION_TITLE: "Data & Retention",
    AI_TEAM_LANDING_DATA_RETENTION_TEXT_1:
      "No AI Agents have edit permissions for employee or absence records. One AI Agent (Morgan) has read only access to employee and absence records for the purpose of report creation and data analysis. Morgan's access is also limited to your access, and he can only analyse the absence data of employee records you already have full access to.",
    AI_TEAM_LANDING_DATA_RETENTION_TEXT_2:
      'Conversations with AI Agents are retained for 180 days only, at which point they are automatically deleted. If you prefer, you can choose to delete conversations earlier via the "Previous Chats" list.',
    AI_TEAM_LANDING_AVAILABILITY_TITLE: "Availability",
    AI_TEAM_LANDING_ADVICE_TITLE: "Advice on speaking to the AI Team",
    AI_TEAM_LANDING_ADVICE_1: "Be clear and instructive. Don't use vague terminology.",
    AI_TEAM_LANDING_ADVICE_2: "Avoid abbreviations as much as you can.",
    AI_TEAM_LANDING_ADVICE_3: "Try to phrase messages as questions where possible.",
    AI_TEAM_LANDING_ADVICE_4:
      "Start new chats often, especially when changing topics or needing something different.",
    AI_TEAM_LANDING_ADVICE_5:
      "Do not refresh your screen while the AI Agent is writing their response, otherwise it will be cancelled.",
    AI_TEAM_LANDING_DIFFICULTY_TITLE: "Difficulty & Experience",
    AI_TEAM_LANDING_DIFFICULTY_TEXT:
      "Talking with AI Agents can sometimes be a complex experience as, unlike a human, they are not adept at picking up on emotional cues or understanding your latent needs. Each AI Agent has a difficulty rating:",
    DIFFICULTY_RATING: "Difficulty Rating",
    AI_TEAM_DIFFICULTY_NOVICE: "Novice",
    AI_TEAM_DIFFICULTY_ADVANCED: "Advanced",
    AI_TEAM_DIFFICULTY_EXPERT: "Expert",
    AI_TEAM_DIFFICULTY_NOVICE_TEXT:
      "Anyone will be capable of speaking to the AI Agent, even if they have no previous experience speaking to AIs. The AI Agents are simple, focused on a small number of areas, and often have contextual prompts that help the user with what they are trying to say.",
    AI_TEAM_DIFFICULTY_ADVANCED_TEXT:
      "The AI Agent has a wider set of permissions, and a huge range of topics they cover. This requires users to carefully articulate what they want and know how to direct and shape the AI's output, otherwise they may get unhelpful responses.",
    AI_TEAM_DIFFICULTY_EXPERT_TEXT:
      "The AI Agent is very powerful and can change your entire service. As such, you should only speak with the Agent if you are confident that you have a deep understanding of how the system works. The AI Agent will have safeguards and checks but will not hold your hand and is expecting you to be confident and know exactly what you are doing.",
    AI_TEAM_LANDING_MISTAKES_TITLE: "Mistakes",
    AI_TEAM_LANDING_MISTAKES_TEXT:
      "AI Agents are not perfect and may sometimes misinterpret or become confused by your requests. If they provide an answer that you are sure is incorrect, let them know and ask them to double check things. AI Agents will make mistakes but, just like a person, they can learn from them. Also, remember to regularly start new chats, instead of discussing multiple different topics in the same chat.",
    AI_TEAM_LANDING_CONFIDENTIALITY_TITLE: "Confidentiality",
    AI_TEAM_LANDING_CONFIDENTIALITY_TEXT:
      "Refrain from including any personal identifiable data in your discussions with the AI Agents. If you do include it, the data will be deleted within 180 days as a safeguard anyway, but it's always best to practice data minimisation when possible. Also, the AI Agents will perform their best when given unique ID's instead of names.",
  },
};
